"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRoleSchema = exports.userRoles = void 0;
const zod_1 = require("zod");
exports.userRoles = [
    'admin',
    'api_partner',
    'attending_doctor',
    'csm',
    'medical_assistant',
    'office_assistant',
    'substitute_doctor',
    'support',
];
exports.userRoleSchema = zod_1.z.enum(exports.userRoles);
